export class WeatherStates {
 public static ar: string[] = [
   'Unknown weather',
   'Cloudy',
   'Shower',
   'Snow shower',
   'Sunny',
   'Overcast',
   'Light rain',
   'Light snow',
   'Moderate rain',
   'Moderate snow',
   'Heavy snow',
   'Heavy rain',
   'Sandstorm',
   'Sleet',
   'Fog',
   'Haze',
   'Thundershower',
   'Snowstorm',
   'Dust',
   'Extraordinary rainstorm',
   'Freezing rain',
   'Thundershowers with hail',
   'Heavy rainstorm',
   'Sand blowing',
   'Strong sandstorm',
   'Rainstorm'
 ]
}

